export const keyPresses = {};

document.addEventListener('keydown', event => {
    keyPresses[event.key] = true;
});

document.addEventListener('keyup', event => {
    keyPresses[event.key] = false;
});
